import { render, staticRenderFns } from "./EnacAtplDashboardPhaseTopBox.vue?vue&type=template&id=c64dcad0"
import script from "./EnacAtplDashboardPhaseTopBox.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardPhaseTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports